/* jshint ignore:start */

// This file list is only used for testing.
// It should be kept in sync with ../skulpt.py.
// Order is important!

require("./util.js");

// Global support functions
Sk.global["strftime"] = require("strftime");
Sk.global["strptime"] = require("../support/time-helpers/strptime.js");
require("setimmediate");

// Skulpt
require("assert");
require("./env.js");
require("./type.js");
require("./abstract.js");
require("./object.js");
require("./function.js");
require("./builtin.js");
require("./fromcodepoint.js");
require("./errors.js");
require("./method.js");
require("./misceval.js");
require("./seqtype.js");
require("./list.js");
require("./str.js");
require("./formatting.js");
require("./tuple.js");
require("./dict.js");
require("./numtype.js");
require("./biginteger.js");
require("./int.js");
require("./bool.js");
require("./float.js");
require("./number.js");
require("./long.js");
require("./complex.js");
require("./slice.js");
require("./set.js");
require("./frozenset.js");
require("./print.js");
require("./module.js");
require("./structseq.js");
require("./generator.js");
require("./file.js");
require("./ffi.js");
require("./iterator.js");
require("./range.js");
require("./enumerate.js");
require("./filter.js");
require("./zip.js");
require("./map.js");
require("./token.js");
require("./filbert.js");
require("./tokenize.js");
require("../gen/parse_tables.js");
require("./parser.js");
require("../gen/astnodes.js");
require("./ast.js");
require("./symtable.js");
require("./compile.js");
require("./import.js");
require("./timsort.js");
require("./sorted.js");
require("./typeobject.js");
require("./builtindict.js");
require("./constants.js");
require("./internalpython.js");

// Angis
if (typeof PIXI !== 'undefined') {

    Sk.Angis = {};

    require("./lib/angis/utils.js");
    require("./lib/angis/pixi.js");
    require("./lib/angis/progressScreen.js");
    require("./lib/angis/promiseCloser.js");
    require("./lib/angis/failai.js");
    require("./lib/angis/rtti.js");
    require("./lib/angis/klaviatūra.js");
    require("./lib/angis/taimeris.js");    
    require("./lib/angis/garsas.js");
    require("./lib/angis/print.js");
    require("./lib/angis/filtrai.js");
    require("./lib/angis/tracer.js");

    // Žaidimas

    Sk.VPŽaidimas = {};

    require("./lib/žaidimas/plytelė.js");
    require("./lib/žaidimas/daiktas.js");
    require("./lib/žaidimas/dekoracija.js");
    require("./lib/žaidimas/veikejas.js");
    require("./lib/žaidimas/indikatorius.js");
    require("./lib/žaidimas/grafika.js");
    require("./lib/žaidimas/sluoksnis.js");
    require("./lib/žaidimas/animacija.js");
    require("./lib/žaidimas/animacijųLapas.js");
    require("./lib/žaidimas/scena.js");
    require("./lib/žaidimas/tekstas.js");
}

/* jshint ignore:end */
